export const SOLID_ICON_HEIGHT = 20;
export const SOLID_ICON_WIDTH = 20;

export const OUTLINE_ICON_HEIGHT = 20;
export const OUTLINE_ICON_WIDTH = 20;
